export const numPerPageOptions = [10, 20, 50];
export const degreeMap ={ 
  2: `Certificate`,
  3:	`Associate`,
  4	:`Bachelors`,
  5:	`Masters`,
  6:	`Doctorate`,
  7: 	`Teacher's Certificate`
}